import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export enum eStyleTlfType {
  Template = "Template",
  Shell = "Shell",
}

export interface StyleAttributeReadDto {
  id: number;
  key: string;
  value: string;
}

export interface RuleReadDto {
  name: string;
}

export interface StyleReadDto {
  id: number;
  name: string;
  tlfItemType: eStyleTlfType;
  styleAttributes: StyleAttributeReadDto[];
  rule: RuleReadDto;
}

export type IStylesReturn = IAxiosReturn<StyleReadDto[]>;

/**
 * Gets all styles. from the back end
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param _ - Unused parameter for consistency with loader signature
 * @param controller - Optional AbortController for cancelling the request
 * @returns Promise<IStylesReturn>
 */
export const getAllStyles = async (
  backEndUrl: string,
  _?: string,
  controller?: AbortController,
): Promise<IStylesReturn> => {
  const url = `${backEndUrl}Styles`;
  // Get data
  try {
    const response: { data: StyleReadDto[] } = await axios.get(
      url,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );
    // Return successful result
    return {
      success: true,
      data: response.data,
    };
  } catch (error: unknown) {
    return processAxiosError("Load styles failed", error);
  }
};
